import { render, staticRenderFns } from "./CourseWare.vue?vue&type=template&id=b5d8f8ea&scoped=true"
import script from "./CourseWare.vue?vue&type=script&lang=js"
export * from "./CourseWare.vue?vue&type=script&lang=js"
import style0 from "./CourseWare.vue?vue&type=style&index=0&id=b5d8f8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d8f8ea",
  null
  
)

export default component.exports